/**
 * View component for /transitions
 *
 * Generic transition list view. Defaults to 'all' with:
 * this.props.dispatch(transitionActions.fetchListIfNeeded());
 *
 * NOTE: See /product/views/ProductList.js.jsx for more examples
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

// import actions
import * as transitionActions from '../transitionActions';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";

// import transition components
import TransitionLayout from '../components/TransitionLayout.js.jsx';
import TransitionListItem from '../components/TransitionListItem.js.jsx';

// import transition css modules
import transitionStyles from '../transitionModuleStyles.css';

class TransitionList extends Base {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    // fetch a list of your choice
    this.props.dispatch(transitionActions.fetchListIfNeeded()); // defaults to 'all'
  }

  render() {
    const { transitionStore } = this.props;

    /**
     * Retrieve the list information and the list items for the component here.
     *
     * NOTE: if the list is deeply nested and/or filtered, you'll want to handle
     * these steps within the mapStoreToProps method prior to delivering the
     * props to the component.  Othwerwise, the render() action gets convoluted
     * and potentially severely bogged down.
     */

    // get the transitionList meta info here so we can reference 'isFetching'
    const transitionList = transitionStore.lists ? transitionStore.lists.all : null;

    /**
     * use the reducer getList utility to convert the all.items array of ids
     * to the actual transition objetcs
     */
    const transitionListItems = transitionStore.util.getList("all");

    /**
     * NOTE: isEmpty is is usefull when the component references more than one
     * resource list.
     */
    const isEmpty = !transitionListItems || !transitionList;

    return (
      <TransitionLayout>
        <div className="flex">
          <section className="section">
            <div className="yt-container">
              <h1> Transition List
                <Link className="yt-btn small u-pullRight" to={'/transitions/new'}> NEW Transition </Link>
              </h1>
              <hr/>
              { isEmpty ?
                (transitionListItems && transitionList && transitionList.isFetching ? <h2>Loading...</h2> : <h2>Empty.</h2>)
                :
                <div style={{ opacity: transitionList.isFetching ? 0.5 : 1 }}>
                  <ul>
                    {transitionListItems.map((transition, i) =>
                      <TransitionListItem key={transition._id} transition={transition} />
                    )}
                  </ul>
                </div>
              }
            </div>
          </section>
        </div>
      </TransitionLayout>
    )
  }
}

TransitionList.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    transitionStore: store.transition
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(TransitionList)
);



// WEBPACK FOOTER //
// modules/transition/views/TransitionList.js.jsx